import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getDonations,
  deleteDonation,
  getNextDonations,
  getPreviousDonations,
} from "../../store/actions/donations_action";
import { LIMIT } from "../../domain/constant";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import {
  SEARCH_TERMS,
  view_all_table,
} from "../../shared/enums/donations_enum";
import DataTable from "../../components/common/DataTable";
const AllDonations = ({
  getDonations,
  deleteDonation,
  getNextDonations,
  getPreviousDonations,
  donation: { loading, donations },
}) => {
  const [page, setPage] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await deleteDonation(deleteEntry);
      }
      getDonations({});
    }
    allQuery();
  }, [deleteEntry]);

  const nextButtonClicked = () => {
    if (donations && donations.length === LIMIT) {
      const lastDonation = donations[donations.length - 1];
      getNextDonations({ last: lastDonation });
      setPage(page + 1);
    }
  };
  const prevBtnClicked = () => {
    if (page > 1) {
      const lastDonation = donations[0];
      getPreviousDonations({
        first: lastDonation,
      });
      setPage(page - 1);
    }
  };
  const filterClicked = () => {
    if (term && term.length > 0) {
      setPage(1);
      setQ(term);
      getDonations({ term: term, termField: termField });
    }
  };
  const deleteDonationClicked = (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPage(1);
    setQ(null);
    setTerm("");
    getDonations({});
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Donations"
          mainLinkTitle="Dashboard"
          mainLinkUrl="/dashboard"
          activeLink="Donation"
        />

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="card"
                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
              >
                <div className="card-body">
                  <AddBtn item="donations" title="Donation" />
                  <hr />

                  <Filters
                    q={q}
                    resetFilter={resetFilter}
                    setTerm={setTerm}
                    term={term}
                    filterClicked={filterClicked}
                    termField={termField}
                    setTermField={setTermField}
                    all_terms={SEARCH_TERMS}
                  />
                  <hr />
                  <div>
                    <DataTable
                      keys={view_all_table}
                      data={donations}
                      field={"donations"}
                      page={page}
                      deleteBtnClicked={deleteDonationClicked}
                      loading={loading}
                    />
                    <Pagination
                      data={donations}
                      page={page}
                      prevBtnClicked={prevBtnClicked}
                      nextButtonClicked={nextButtonClicked}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({ donation: state.donation });

const mapDispatchToProps = {
  getDonations,
  deleteDonation,
  getNextDonations,
  getPreviousDonations,
};

export default connect(mapStateToProps, mapDispatchToProps)(AllDonations);
